var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewJimatlyMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338.59,
    height: 105.6,
    viewBox: "0 0 338.59 105.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.29 81.6)",
    fontSize: 96,
    fill: "#00a79d",
    fontFamily: "Cabin-Bold, Cabin",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "J", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 27.07,
    y: 0,
    letterSpacing: "0em"
  }, "I")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 53.66,
    y: 0
  }, "M")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 133.63,
    y: 0,
    letterSpacing: "-0.05em"
  }, "A")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 188.54,
    y: 0
  }, "T")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 241.73,
    y: 0,
    letterSpacing: "-0.1em"
  }, "L")), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 280.22,
    y: 0
  }, "Y")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJimatlyMainLogo);
export default __webpack_public_path__ + "static/media/newJimatlyMainLogo.309f6b7ba70bcb9edb0e3bdbe98fe90b.svg";
export { ForwardRef as ReactComponent };